
import React from 'react';

import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { Footer } from '../../../welcome/components/Footer';
import { Header } from '../../../welcome/components/Header';
import AbstractPageReloadOverlay, {
    type Props,
    abstractMapStateToProps
} from '../AbstractPageReloadOverlay';

import OverlayFrame from './OverlayFrame';
import { styelOverlay } from './style';

/**
 * Implements a React Component for page reload overlay. Shown before the
 * conference is reloaded. Shows a warning message and counts down towards the
 * reload.
 */
class PageReloadOverlay extends AbstractPageReloadOverlay<Props> {


    /**
     * Implements React's {@link Component#UNSAFE_componentWillMount()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    UNSAFE_componentWillMount() {
        const linkofCss = document.querySelector('#linkStyle');
        const scriptFile = document.querySelector('#mainJS');

        if ((!linkofCss && document.head) || (!scriptFile && document.body)) {
            const link = document.createElement('link');

            link.href = '/static/assets/css/style.css';
            link.id = 'linkStyle';
            document.head && document.head.appendChild(link);

            const script = document.createElement('script');

            script.src = '/static/assets/js/main.js';
            script.id = 'mainJS';
            script.async = true;
            document.body && document.body.appendChild(script);
        }
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { isNetworkFailure, t, interfaceConfig } = this.props;
        const { title } = this.state;

        return (
            <OverlayFrame isLightOverlay = { isNetworkFailure }>
                <Header
                    prejoin = { false } />
                <div
                    className = 'container'
                    style = { styelOverlay(interfaceConfig).overlayContainer }>
                    <div className = 'row'>
                        <div className = 'col-m-12 col-sm-12'>
                            <br /><br /><br />
                            <div
                                style = { styelOverlay(interfaceConfig).pageReload }>
                                <br />
                                <div className = ''>

                                    <h4
                                        style = { styelOverlay(interfaceConfig).overlayH4 }>
                                        {t(title)}
                                    </h4>
                                </div>
                                {this._renderProgressBar()}
                                <br />
                                {/* <hr /> */}
                                { this._renderButton() }


                            </div>
                            <br /><br />


                        </div>


                    </div>
                </div>
                <Footer
                    prejoin = { false }
                    style = { styelOverlay(interfaceConfig).footerStyle } />
            </OverlayFrame>
        );
    }

    _renderButton: () => React$Element<*>;

    _renderProgressBar: () => React$Element<*>;
}

export default translate(connect(abstractMapStateToProps)(PageReloadOverlay));
